export default "__VITE_ASSET__4f0bb55a__"